import { ComponentType } from 'react';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { fetchSearch } from 'client/ducks/search/actions';
import { getSearchPage, isLoading, hasMore, getLastSearchValue } from 'client/ducks/search/selectors';
import { State } from 'client/store';

import SearchPage, { DispatchProps, StateProps } from './search';

function mapStateToProps(state: State): StateProps {
    return {
        ...getSearchPage(state),
        lastSearchValue: getLastSearchValue(state),
        hasMore: hasMore(state),
        isLoading: isLoading(state)
    };
}

const mapDispatchToProps = { fetchSearchPage: fetchSearch };

const component = compose<ComponentType>(
    connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps),
    withRouter
)(SearchPage) as any;

component.asyncFetchData = SearchPage.asyncFetchData;

export default component;
